import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Autocomplete, AutocompleteChangeDetails, Grid, TextField } from '@mui/material';
import NumberFormatCustom from '../../NumberFormatCustom/NumberFormatCustom';

interface DwtSelectorProp {
    dwtFromValue: number | null,
    dwtToValue: number | null,
    dwtFromLabel?: string,
    dwtToLabel?: string,
    className?: string,
    useSizeSelector: boolean,
    disabled?: boolean,
    onDwtFromChange?: (value: number) => void,
    onDwtToChange?: (value: number) => void,
    onDwtFromBlur?: () => void,
    onDwtToBlur?: () => void,
}

interface SizeOption {
    value: string,
    text: string
}

const DwtSelector: React.FunctionComponent<DwtSelectorProp> = (props) => {
    const [defaultOptions, setDefaultOptions] = useState<SizeOption[]>([]);

    useEffect(() => {
        let options = [
            {
                value: "1,10",
                text: "1 to 10"
            } as SizeOption,
            {
                value: "10,20",
                text: "10 to 20"
            } as SizeOption,
            {
                value: "20,35",
                text: "20 to 35"
            } as SizeOption,
            {
                value: "35,55",
                text: "35 to 55"
            } as SizeOption,
            {
                value: "55,65",
                text: "55 to 65"
            } as SizeOption,
        ];

        setDefaultOptions(options);
    }, [])

    return (
        <>
            <Grid
                className={props.className ? props.className : ""}
                container>
                <Grid item xs={props.useSizeSelector ? 4 : 6}>
                    <TextField
                        fullWidth
                        label={props.dwtFromLabel ? props.dwtFromLabel : "Dwt From"}
                        disabled={props.disabled === true ? true : false}
                        InputProps={{
                            inputComponent: NumberFormatCustom as any,
                        }}
                        value={props.dwtFromValue ? props.dwtFromValue : ""}
                        onChange={(event) => {
                            if (props.onDwtFromChange) {
                                let value = event.target.value ? parseFloat(event.target.value) : 0;
                                props.onDwtFromChange(value)
                            }
                        }}
                        onBlur={() => {
                            if (props.onDwtFromBlur) {
                                props.onDwtFromBlur();
                            }
                        }}
                    >
                    </TextField>
                </Grid>
                <Grid item xs={props.useSizeSelector ? 4 : 6}>
                    <TextField
                        fullWidth
                        label={props.dwtToLabel ? props.dwtToLabel : "Dwt To"}
                        disabled={props.disabled === true ? true : false}
                        InputProps={{
                            inputComponent: NumberFormatCustom as any,
                        }}
                        value={props.dwtToValue ? props.dwtToValue : ""}
                        onChange={(event) => {
                            if (props.onDwtToChange) {
                                let value = event.target.value ? parseFloat(event.target.value) : 0;
                                props.onDwtToChange(value)
                            }
                        }}
                        onBlur={() => {
                            if (props.onDwtToBlur) {
                                props.onDwtToBlur();
                            }
                        }}
                    >
                    </TextField>
                </Grid>
                {props.useSizeSelector &&
                    <Grid item xs={4}>
                        <Autocomplete
                            options={defaultOptions}
                            renderInput={(params) => <TextField {...params} label="Size" />}
                            disabled={props.disabled === true ? true : false}
                            getOptionLabel={(option: SizeOption) => {
                                return option.text;
                            }}
                            onChange={(event: React.SyntheticEvent, value: SizeOption | null, reason: string, details?: AutocompleteChangeDetails<SizeOption> | undefined) => {
                                if (value) {
                                    let dwtFrom = parseInt(value.value.split(",")[0]) * 1000;
                                    let dwtTo = parseInt(value.value.split(",")[1]) * 1000;

                                    if (props.onDwtFromChange) {
                                        props.onDwtFromChange(parseFloat(dwtFrom.toString()));
                                    }

                                    if (props.onDwtToChange) {
                                        props.onDwtToChange(parseFloat(dwtTo.toString()));
                                    }
                                }
                            }}
                        />
                    </Grid>
                }
            </Grid>
        </>
    )
};

export default DwtSelector;